(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["zoo-pack-dropdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zoo-pack-dropdown')) {
    class ZooPackDropdown extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.zoo-pack-dropdown__trigger');
        this.panel = this.querySelector('.zoo-pack-dropdown__panel');
        this.card = this.closest('product-card') || this.closest('.product-card');
        if (!this.trigger || !this.panel) return;

        this._onOutside = (e) => {
          if (!this.contains(e.target)) this.close();
        };
        this._onKeydown = (e) => this.handleKeydown(e);

        // Stop klik i at nå kortets link-overlay / view transition handler
        this.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          // Klik på backdrop (::before pseudo-elementet rammer host-elementet selv)
          if (e.target === this) {
            this.close();
            return;
          }

          if (e.target.closest('.zoo-pack-dropdown__trigger')) {
            this.toggle();
            return;
          }
          const option = e.target.closest('[role="option"]');
          if (option && !option.hasAttribute('data-unavailable')) {
            this.select(option);
          }
        });

        this.addEventListener('keydown', this._onKeydown);
      }

      disconnectedCallback() {
        document.removeEventListener('pointerdown', this._onOutside, true);
        document.body.style.overflow = '';
      }

      get isOpen() {
        return !this.panel.hidden;
      }

      toggle() {
        this.isOpen ? this.close() : this.open();
      }

      open() {
        this.panel.hidden = false;
        this.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
        document.addEventListener('pointerdown', this._onOutside, true);

        // Lås body-scroll bag bottom sheeten på mobil
        if (window.matchMedia('(max-width: 749px)').matches) {
          document.body.style.overflow = 'hidden';
        }
      }

      close() {
        if (!this.isOpen) return;
        document.body.style.overflow = '';
        this.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('pointerdown', this._onOutside, true);
        // Vent på fade/slide-out før hidden, så animationen når at spille
        const panel = this.panel;
        const done = () => {
          panel.hidden = true;
          panel.removeEventListener('transitionend', done);
        };
        panel.addEventListener('transitionend', done);
        // Fallback hvis transitionend ikke fyrer (fx reduced motion)
        setTimeout(done, 300);
      }

      handleKeydown(e) {
        const options = [...this.panel.querySelectorAll('[role="option"]:not([data-unavailable])')];
        if (e.key === 'Escape') {
          this.close();
          this.trigger.focus();
        } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          if (!this.isOpen) this.open();
          const current = options.indexOf(document.activeElement);
          const next = e.key === 'ArrowDown'
            ? Math.min(current + 1, options.length - 1)
            : Math.max(current - 1, 0);
          options[next === -1 ? 0 : next]?.focus();
        } else if ((e.key === 'Enter' || e.key === ' ') && document.activeElement?.matches('[role="option"]')) {
          e.preventDefault();
          this.select(document.activeElement);
        }
      }

      select(option) {
        // Opdater aria-selected
        this.panel.querySelectorAll('[role="option"]').forEach((el) => {
          el.setAttribute('aria-selected', String(el === option));
        });

        // Opdater trigger (ikon, titel, pris)
        const { title, price, icon, variantId, variantUrl } = option.dataset;
        const iconEl = this.querySelector('[data-zp-icon]');
        if (iconEl) {
          iconEl.textContent = icon || '';
          iconEl.hidden = !icon;
        }
        const labelEl = this.querySelector('[data-zp-label]');
        if (labelEl) labelEl.textContent = title || '';
        const priceEl = this.querySelector('[data-zp-price]');
        if (priceEl) priceEl.textContent = price || '';

        // Opdater kortets link, så klik på kortet lander på den valgte variant
        if (this.card && variantUrl) {
          const link = this.card.querySelector('.product-card__link');
          if (link) link.href = variantUrl;
        }

        // Opdater evt. quick-add / product form i kortet
        if (this.card && variantId) {
          this.card.querySelectorAll('input[name="id"]').forEach((input) => {
            input.value = variantId;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        // Hook til andre scripts (fx hvis vi senere vil skifte kort-billede)
        this.dispatchEvent(
          new CustomEvent('zoo:variant-change', {
            bubbles: true,
            detail: { variantId, variantUrl, productId: this.dataset.productId },
          })
        );

        this.close();
        this.trigger.focus();
      }
    }

    customElements.define('zoo-pack-dropdown', ZooPackDropdown);
  }
  } catch(e) { console.error(e); }
})();

})();
